<template>
  <div
    class="menu-trigger"
    @click.stop="toggle"
  >
    <i class="pi pi-ellipsis-h"></i>
  </div>

  <OverlayPanel ref="menuOp">
    <div class="flex flex-col gap-4">
      <div
        v-if="props.canEdit"
        class="cursor-pointer"
        @click="emitAndHide('edit')"
      >
        {{ _t('package.edit_card') }}
      </div>
      <div
        v-if="props.canCreate"
        class="cursor-pointer"
        @click="emitAndHide('createBefore')"
      >
        {{ _t('package.edit_card_before') }}
      </div>
      <div
        v-if="props.canCreate"
        class="cursor-pointer"
        @click="emitAndHide('createAfter')"
      >
        {{ _t('package.edit_card_after') }}
      </div>
      <div
        v-if="props.canCopy"
        class="cursor-pointer"
        @click="emitAndHide('copy')"
      >
        {{ _t('package.copy_card') }}
      </div>
      <div
        :class="[
          'cursor-pointer text-red-500',
          {
            'opacity-30': !props.canDelete,
          },
        ]"
        @click="onDelete"
      >
        {{ _t('package.delete_card') }}
      </div>
    </div>
  </OverlayPanel>
</template>

<script lang="ts" setup>
import bus, { BusEvent } from '@/bus/bus'
import OverlayPanel from '@/components/OverlayPanel.vue'
import { onUnmounted, onMounted, ref } from 'vue'

const props = withDefaults(
  defineProps<{
    canDelete?: boolean
    canEdit?: boolean
    canCreate?: boolean
    canCopy?: boolean
  }>(),
  {
    canDelete: true,
    canEdit: true,
    canCreate: true,
    canCopy: true,
  }
)

const emit = defineEmits<{
  edit: []
  createBefore: []
  createAfter: []
  copy: []
  delete: []
}>()

const menuOp = ref()

const toggle = (event: MouseEvent) => {
  menuOp.value.toggle(event)

  if (menuOp.value.visible) {
    bus.emit(BusEvent.OverlayPanelShow, menuOp.value)
  }
}

function emitAndHide(
  event: 'edit' | 'createBefore' | 'createAfter' | 'copy' | 'delete'
) {
  if (event === 'edit') {
    emit('edit')
  } else if (event === 'createBefore') {
    emit('createBefore')
  } else if (event === 'createAfter') {
    emit('createAfter')
  } else if (event === 'copy') {
    emit('copy')
  } else if (event === 'delete') {
    emit('delete')
  }

  menuOp.value.hide()
}

function onOtherMenuOpen(op: any) {
  if (op !== menuOp.value) {
    menuOp.value.hide()
  }
}

function onDelete() {
  if (props.canDelete) {
    emitAndHide('delete')
  }
}

onMounted(() => {
  bus.on(BusEvent.OverlayPanelShow, onOtherMenuOpen)
})

onUnmounted(() => {
  bus.off(BusEvent.OverlayPanelShow, onOtherMenuOpen)
})
</script>

<style scoped>
.menu-trigger {
  cursor: pointer;
}
</style>
